import Const from 'constants';

const defaultState = {
    data: {},
    isLocked(playerId, mode = Const.FLEX_MODE) {
        return this.data.hasOwnProperty(mode) && this.data[mode].hasOwnProperty(playerId);
    },
    isLockedAnywhere(playerId) {
        const data = Object.values(this.data);

        for (const mode of data) {
            if (playerId in mode) {
                return true;
            }
        }

        return false;
    },
    getLockedPlayerIds(mode = Const.FLEX_MODE) {
        return mode in this.data ? Object.keys(this.data[mode]).map(String) : [];
    },
    getMergedLockedPlayerIds() {
        let result = [];
        Object.keys(this.data).map((mode) => {
            result = [...result, ...this.getLockedPlayerIds(mode)];
        });

        return result;
    },
    all() {
        return {...this.data};
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.LOCKING_SET_PLAYERS) {
        Object.keys(action.items).map((mode) => {
            state.data[mode] ??= {};
            Object.keys(action.items[mode]).map((playerId) => {
                if (Boolean(action.items[mode][playerId])) {
                    state.data[mode][playerId] = true;
                } else if (state.data[mode].hasOwnProperty(playerId)) {
                    delete state.data[mode][playerId];
                }
            });
        });
    } else if (action.type === Const.EXCLUSION_SET_PLAYERS) {
        Object.keys(action.items).map((mode) => {
            if (!state.data.hasOwnProperty(mode)) {
                return;
            }
            Object.keys(action.items[mode]).map((playerId) => {
                if (Boolean(action.items[mode][playerId]) && state.data[mode].hasOwnProperty(playerId)) {
                    delete state.data[mode][playerId];
                }
            });
        });
    } else if (action.type === Const.CORRELATION_STACKING_RESTRICT_PLAYERS) {
        Object.keys(action.items).map((playerId) => {
            if (Boolean(action.items[playerId])) {
                Object.keys(state.data).map((mode) => {
                    if (state.data[mode].hasOwnProperty(playerId)) {
                        delete state.data[mode][playerId];
                    }
                });
            }
        });
    } else if (action.type === Const.NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS) {
        Object.keys(action.checkedPlayers).map((playerId) => {
            if (Boolean(action.checkedPlayers[playerId])) {
                Object.keys(state.data).map((mode) => {
                    if (state.data[mode].hasOwnProperty(playerId)) {
                        delete state.data[mode][playerId];
                    }
                });
            }
        });
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState, data: {}};
    }

    return state;
}
